// Manages asynchronous user search and assignment UI within a project.
import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = { url: String, delay: Number }

  connect() {
    this.timeout = null
    this.hideResults()

    // Reset search state once a selected user is appended to the list.
    document.addEventListener("turbo:before-stream-render", (event) => {
      if (event.target.action === "append" &&
          event.target.target === "project_users_items") {
        this.reset()
      }
    })
  }

  search() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()

    // Avoid noisy backend lookups for very short queries.
    if (query.length < 2) {
      this.clearResults()
      this.hideResults()
      return
    }

    this.showResults()
    this.resultsTarget.innerHTML =
        `<div class="text-muted small p-2">Searching…</div>`

    this.timeout = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("query", query)

      fetch(url.toString(), {
        headers: { Accept: "text/vnd.turbo-stream.html" }
      })
          .then(r => r.text())
          .then(html => {
            Turbo.renderStreamMessage(html)
          })
    }, this.delayValue || 250)
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
    this.showResults()
  }

  showResults() {
    this.resultsTarget.classList.remove("d-none")
    this.resultsTarget.classList.add("fade", "show")
  }

  hideResults() {
    this.resultsTarget.classList.add("d-none")
  }

  reset() {
    this.inputTarget.value = ""
    this.clearResults()
    this.hideResults()
    this.inputTarget.focus()
  }
}
